import { render, staticRenderFns } from "./Remind.vue?vue&type=template&id=33bd1c71&scoped=true"
import script from "./Remind.vue?vue&type=script&lang=js"
export * from "./Remind.vue?vue&type=script&lang=js"
import style0 from "./Remind.vue?vue&type=style&index=0&id=33bd1c71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd1c71",
  null
  
)

export default component.exports